var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M14.94,33a6.926,6.926,0,0,1-4.817-1.939,1.078,1.078,0,0,1,0-1.543H2.394A2.378,2.378,0,0,1,.1,27.894a2.1,2.1,0,0,1,1-2.457c.3-.265,2.926-2.822,2.926-10.869A11.57,11.57,0,0,1,7.032,7.081a11.23,11.23,0,0,1,3.68-2.762.972.972,0,0,1,0-.2A4.224,4.224,0,0,1,15.027,0a4.225,4.225,0,0,1,4.316,4.117,1.208,1.208,0,0,1,0,.2,11.24,11.24,0,0,1,3.679,2.762,11.564,11.564,0,0,1,3.013,7.487c0,8.061,2.634,10.626,2.934,10.892a2.1,2.1,0,0,1,.918,2.478,2.375,2.375,0,0,1-2.3,1.626H19.757a1.077,1.077,0,0,1,0,1.5A6.921,6.921,0,0,1,14.94,33Zm-3.082-3.466a4.467,4.467,0,0,0,3.088,1.235H15a4.463,4.463,0,0,0,3.059-1.235ZM4.679,24.3A7.306,7.306,0,0,1,2.5,27.295H27.611A7.308,7.308,0,0,1,25.43,24.3H4.679ZM15.051,5.585c-4.94,0-8.631,4.743-8.631,8.984A27.093,27.093,0,0,1,5.5,22.055H24.6a27.15,27.15,0,0,1-.918-7.486C23.681,10.328,19.99,5.585,15.051,5.585Zm0-2.247a9.447,9.447,0,0,1,1.836.18,2.153,2.153,0,0,0-1.836-1.3,2.15,2.15,0,0,0-1.836,1.3A9.452,9.452,0,0,1,15.051,3.338Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.83187ef8c09400daac259f21ba8d71c0.svg";
export { ForwardRef as ReactComponent };